import React from "react";
import {
  isEmptyRichText,
  isRichTextHtml,
  sanitizeDiaryHtml,
} from "./DiaryTeacher.utils";
import styles from "./DiaryRichTextCell.module.css";

interface DiaryRichTextCellProps {
  value?: string | null;
  fallback?: string;
}

/**
 * Renders a diary text field that may be either legacy plain text or the
 * rich-text HTML fragment stored by the new editor.
 */
const DiaryRichTextCell: React.FC<DiaryRichTextCellProps> = ({
  value,
  fallback = "-",
}) => {
  if (isEmptyRichText(value)) {
    return <>{fallback}</>;
  }

  if (isRichTextHtml(value)) {
    return (
      <div
        className={`diary-rich-text ${styles.richText}`}
        dangerouslySetInnerHTML={{ __html: sanitizeDiaryHtml(value) }}
      />
    );
  }

  return <span style={{ whiteSpace: "pre-wrap" }}>{value}</span>;
};

export default DiaryRichTextCell;
